import { Mail, ShoppingCart, Zap } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateCartRecoveryAr: TemplateAr = {
  name: 'أتمتة استرجاع السلات المتروكة بالذكاء الاصطناعي',
  description:
    'استعِد العملاء اللي تركوا سلاتهم بمتابعات مخصصة عبر الإيميل أو الرسائل النصية أو المكالمات.',
  category: 'التجارة الإلكترونية',
  workflow: [
    { icon: ShoppingCart, label: 'سلة متروكة' },
    { icon: Mail, label: 'متابعة ذكية' },
    { icon: Zap, label: 'تحويل', final: true },
  ],
  detailDescription: {
    paragraph1:
      'استرجع العميل اللي ترك سلته برسالة متابعة مخصصة. أول ما يترك منتجاته في السلة، الـ AI يشغّل سلسلة تواصل عبر الإيميل أو الرسائل النصية أو المكالمات، حسب اللي تفضّله. وكل رسالة مخصصة بناءً على محتوى السلة وسجل العميل وسلوك شرائه السابق.',
    paragraph2:
      'حملات الاسترجاع وبيانات التحويل توصل للأدوات اللي تفضّلها: تنبيهات Slack لحظية، أو تحديثات CRM لتتبّع الإسناد، أو تصدير Excel/CSV لتحليل الحملات. والـ AI يعدّل التوقيت والرسالة والقناة حسب أنماط سلوك العملاء، عشان يرفع معدلات التحويل.',
  },
  benefits: [
    'الـ AI يستعيد السلات المتروكة تلقائياً',
    'توصل للعميل بالإيميل أو الرسائل النصية أو المكالمة',
    'التوقيت من سلوك العميل، مو من جدول ثابت',
    'تختبر الرسائل والتوقيت باختبار A/B تلقائياً',
    'تتبّع إسناد كل سلة تسترجعها',
    'إيرادات أعلى لمتجرك. بلا عمل يدوي.',
  ],
};
